import React, { useContext } from 'react';
import { DefaultSettingsAdapter } from '../components/PackagePicker/DefaultSettingsAdapter';
import { SettingsParamsProvider } from './useSettingsParams';

const SettingsAdapterContext = React.createContext<DefaultSettingsAdapter>({} as DefaultSettingsAdapter);

interface SettingsAdapterProviderProps {
  adapter: DefaultSettingsAdapter;
  children: React.ReactNode;
}

export const SettingsAdapterProvider: React.FC<SettingsAdapterProviderProps> = ({ children, adapter }) => {
  return (
    <SettingsParamsProvider settingsParams={adapter.params}>
      <SettingsAdapterContext.Provider value={adapter}>{children}</SettingsAdapterContext.Provider>
    </SettingsParamsProvider>
  );
};

export const useAdaptedSettings = () => useContext(SettingsAdapterContext);
